module.exports = __webpack_public_path__ + "static/media/ot-courier-default.d4e2efe4.svg";